/* global axios */
import ApiClient from './ApiClient';

const buildQuestionParams = (page, perPage, sortBy, sortOrder, filter) => {
  let params = `page=${page}&per_page=${perPage}&sort_by=${sortBy}&sort_order=${sortOrder}&filter_category_id=${filter}`;
  return params;
};
class Questions extends ApiClient {
  constructor() {
    super('sources/questions', { accountScoped: true });
  }

  async get(page, perPage, sortBy, sortOrder, filter) {
    const requestURL = `${this.url}?${buildQuestionParams(page, perPage, sortBy, sortOrder, filter)}`;
    return axios.get(requestURL);
  }
}

export default new Questions();
